import React from 'react';

import CloseIcon from '../icons/CloseIcon';

const CSS = require('./CloseButton.module.scss');

function CloseButton({ onClick }) {
  return (
    <button className={CSS.CloseButton} onClick={onClick} aria-label="close">
      <CloseIcon className={CSS.CloseIcon} />
    </button>
  );
}

export default CloseButton;
